module.exports = __webpack_public_path__ + "static/img/menage8.496f5daa.jpg";